import React, { useCallback, useContext } from 'react'
import Group from 'components/utils/Group'
import FormatCurrency from 'components/Common/FormatCurrency'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import CruisesDiscountTsAndCsModal from 'components/Cruises/CruisesDiscountTsAndCsModal'
import ModalContext from 'contexts/ModalContext'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import PriceRowTaxesAndFees from 'LuxKit/PricePoints/PriceRowTaxesAndFees'
import TextButton from 'LuxKit/Button/TextButton'
import { CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'

interface Props {
  view: CruiseOfferView
  isStandalone?: boolean
  cabinCategoryFromFilter?: string
}

function CruiseTilePrices(props: Props) {
  const {
    view,
    isStandalone,
    cabinCategoryFromFilter,
  } = props
  const {
    cabinCategory,
    lowestPrice,
    hasOnlySuitesAvailable,
    discountPills,
  } = view
  const showModal = useContext(ModalContext)
  const openDiscountTermsAndConditionsModal = useCallback(() => {
    showModal(<CruisesDiscountTsAndCsModal />)
  }, [showModal])

  return (
    <Group gap={8} direction="vertical" fullWidth noDisplayWhenEmpty>
      <Group
        fullWidth
        gap={4}
        direction="horizontal"
        tabletDirection="vertical"
        horizontalAlign="space-between"
        tabletHorizontalAlign="start"
        verticalAlign="end"
        noDisplayWhenEmpty
      >
        {(isStandalone || cabinCategoryFromFilter || hasOnlySuitesAvailable) && <>
          <div>
            {cabinCategory && (
              <PriceRowPriceCaption>
                {cabinCategory} from
              </PriceRowPriceCaption>
            )}
            {lowestPrice && (
              <PriceRowPrice
                size="L"
                price={lowestPrice.primaryPrice.total}
                saleUnit={lowestPrice.primaryPrice.type}
              />
            )}
            {lowestPrice?.secondaryPrice && <PriceRowCaption>
              <FormatCurrency value={lowestPrice.secondaryPrice.total} /> /{lowestPrice.secondaryPrice.type} · Twin Share
            </PriceRowCaption>}
            {!lowestPrice?.secondaryPrice && discountPills?.price && discountPills.discountPercentage && <PriceRowValueDiscountWithCaption
              size="M"
              originalValue={discountPills.price}
              discountPercentage={discountPills.discountPercentage}
              onInfoIconClick={openDiscountTermsAndConditionsModal}
            />}
            {!lowestPrice?.secondaryPrice && <PriceRowCaption>Twin Share</PriceRowCaption>}
            <PriceRowTaxesAndFees />
          </div>
          <CSSBreakpoint max="mobile">
            <TextButton kind="primary">View</TextButton>
          </CSSBreakpoint>
        </>}
      </Group>
    </Group>
  )
}

export default CruiseTilePrices
